import declare from "dojo/_base/declare";
import PathMatrix from "csi/table/matrix/Path";
import xml from "csi/xml";

const QuantityPerSizeMatrix = declare(PathMatrix, {

	matrixNode: null,
		
	productSizes: null,

	/**
		 * Get shipment order product sizes
		 */
	getProductSizes: function(ctx) {
		if (this.productSizes && this.matrixNode == ctx.getNodeContext()) {
			return this.productSizes;
		}

		this.matrixNode = ctx.getNodeContext();
		let poProduct;
			
		switch (this.matrixNode.$Type) {
			case "Shipment":
				poProduct = ctx.cache.getPathNode(this.matrixNode, "Child:Order/Child:POProduct");
				break;
			case "PackListItem":
				poProduct = ctx.cache.getPathNode(this.matrixNode, "Child:Shipment/Child:Order/Child:POProduct");
				break;
			case "PackListCarton":
				poProduct = ctx.cache.getPathNode(this.matrixNode, "Child:__Parent__/Child:Shipment/Child:Order/Child:POProduct");
				break;
			default:
				break;
		}
			
 			this.productSizes = poProduct?.ProductSizes || [];
		return this.productSizes;
	},
	
	/**
		 * @override
		 * Create sells for each of the size nodes
		 * @param {Context} ctx
		 * @param {Spec} spec
		 * @param {Node[]} nodes
		 * @return {Array}
		 */
	_getSpecIndices: function(ctx, spec, nodes) {
		const productSizes = this.getProductSizes(ctx);
		if (productSizes) {
			return Array.from(productSizes.keys());
		}
		return null;
	},
	
	/**
		 * @override
		 * Get shipment order product size nodes
		 * @param {Context} ctx
		 * @param {Spec} spec
		 * @param {Node[]} nodes
		 * @return {Node[]}
		 */
	_getSpecNodes: function(ctx, spec, nodes) {
		if (spec.heading.m_id == xml.ATTR_NAME) {
			const productSizes = this.getProductSizes(ctx);
			if (productSizes) {
				return ctx.cache.getNodes(productSizes);
			}
		}
		return this.inherited(arguments);
	},
	
});
	
export = QuantityPerSizeMatrix;